<template>
  <div>
    <Device v-if="!canJoinLesson" @join="forceRerender"></Device>
    <Lesson v-else key></Lesson>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import CmsPreview from '@/mixins/cmsPreview';
import Device from '@/components/Lesson/Device';
import Lesson from '@/components/Lesson';
import DetectSpeed from '@/utils/detectSpeed';

export default {
  mixins: [CmsPreview],
  components: {
    Device,
    Lesson
  },
  data() {
    return {
      canJoinLesson: false
    };
  },
  created() {
    DetectSpeed.speedStatus();
    this.allowCMSPreviewRegardlessOfJoinStatus();

    if (this.lessonToken) {
      this.initializeSocket();
    }
  },
  computed: {
    ...mapState(['lessonToken']),
  },
  methods: {
    ...mapActions('socketio', ['initializeSocket']),

    forceRerender() {
      this.canJoinLesson = true;
      this.allowCMSPreviewRegardlessOfJoinStatus();
      this.$forceUpdate();
    },
    allowCMSPreviewRegardlessOfJoinStatus() {
      if (this.isCmsPreview) {
        this.canJoinLesson = true;
      }
    }
  }
};
</script>
